import { sortingMethods } from '../../../../constants/table';
import CustomCell from '../../../../components/Table/CustomCell';
import { PORTAL_ROUTE } from '../../../../constants/routes';

export const managedInstallersTableColumnsOrder = [
  { name: 'binaryName', styles: { wordBreak: 'break-word' } },
  { name: 'publisherName', styles: { wordBreak: 'break-word' } },
  { name: 'deviceCount' },
  { name: 'lastSeen' },
];

export const managedInstallersTableHeadings = [
  {
    title: 'Binary Name',
    name: 'binaryName',
    hasSorting: true,
    width: '24%',
    sortMethod: sortingMethods.initial,
    field: 'FilterManagedInstallersResult',
    sortingCellField: 'BinaryName',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Publisher',
    name: 'publisherName',
    hasSorting: true,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterManagedInstallersResult',
    sortingCellField: 'PublisherName',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Device Count',
    name: 'deviceCount',
    hasSorting: true,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterManagedInstallersResult',
    sortingCellField: 'DeviceCount',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Last seen',
    name: 'lastSeen',
    hasSorting: true,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterManagedInstallersResult',
    sortingCellField: 'LastSeen',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
];

export const managedInstallerRuleStatusList = [
  {
    id: 'Active',
    label: 'Active',
    value: 'Active',
    name: 'Active',
  },
  {
    id: 'Inactive',
    label: 'Inactive',
    value: 'Inactive',
    name: 'Inactive',
  },
];

export const managedInstallersSidebarList = [
  {
    title: 'Device tags',
    name: 'Tags',
  },
  {
    title: 'Status',
    name: 'FilterDeviceManagedInstallerRuleStatuses',
    options: managedInstallerRuleStatusList,
  },
];

const fmt = (value, loading) => (loading ? '...' : (value ?? 0));

export const wdacManagedInstallersTabs = (
  managedInstallerId,
  counts,
  unaffectedCounts,
  loading = false,
) => [
  {
    label: `General`,
    value: `${PORTAL_ROUTE}/managed-installer-details/${managedInstallerId}/general`,
  },
  {
    label: `Devices with managed installer (${fmt(counts, loading)})`,
    value: `${PORTAL_ROUTE}/managed-installer-details/${managedInstallerId}/devices`,
  },
  {
    label: `Devices without managed installer (${fmt(unaffectedCounts, loading)})`,
    value: `${PORTAL_ROUTE}/managed-installer-details/${managedInstallerId}/unaffected-devices`,
  },
];

export const trustedStatus = 'Trusted';

export const WDAC_MANAGED_INSTALLERS_PREVIOUS_PATH = 'wdacmanagedinstallers';
